import { en } from './en'
import { nb } from './nb'
import { nn } from './nn'

export type Texts = typeof nb
export type Locale = 'nb' | 'nn' | 'en'

const textsMap: Record<Locale, Texts> = { nb, nn, en }

export function getTexts(locale: Locale): Texts {
    return textsMap[locale] ?? textsMap.nb
}

export function getLocaleFromPath(pathname: string): Locale {
    const segment = pathname.split('/')[1]
    return segment === 'nn' || segment === 'en' ? segment : 'nb'
}
